import styled from 'styled-components'
import { colors } from '../..'
import { defaultTheme } from '../../theming/data/defaultTheme'
import { composeTheme } from '../../utils/compose-theme'

export const Select = styled.select.attrs((props) => composeTheme(props))`
  background: ${colors.neutralColorHighPure};
  border: 0.2rem solid ${colors.neutralColorLowLight};
  box-sizing: border-box;
  border-radius: 0.4rem;
  width: 9rem;
  height: 3.6rem;
  margin: 0.8rem 0;

  &:focus {
    border: 0.2rem solid ${(props) => props.theme.brandColors.primaryPure};
    outline: none;
  }

  &.icon {
    position: absolute;
    margin: 1.4rem;
  }
`
Select.defaultProps = defaultTheme

export const Option = styled.option`
  color: ${colors.neutralColorLowDark};
`
